import type { ScopedThreadRef } from "@afar-research/contracts";
import { useServerConfigs, useThread } from "../state/entities";

/** Resolve controls against the thread's native session before its model selection. */
export function useThreadProvider(ref: ScopedThreadRef | null) {
  const thread = useThread(ref);
  const configs = useServerConfigs();
  const config = ref ? configs.get(ref.environmentId) : undefined;
  const instanceId = thread?.session?.providerInstanceId ?? thread?.modelSelection.instanceId;
  const provider = config?.providers.find((candidate) => candidate.instanceId === instanceId);
  return {
    thread,
    config,
    instanceId,
    provider,
    driver: provider?.driver ?? thread?.session?.providerName,
  };
}
